import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "color",
    style: _normalizeStyle(`background-color: ${_ctx.color}; --color: ${_ctx.color}`)
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.color), 1),
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      value: _ctx.color,
      name: "colors[]",
      disabled: _ctx.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.colorFilter) = $event)),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleColor && _ctx.toggleColor(...args)))
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _ctx.colorFilter]
    ])
  ], 4))
}